<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
  >
    <!-- <template slot="header">
      <h5 class="modal-title">{{ $t("Site Information") }}</h5>
    </template> -->
    <template slot="body">
      <div class="text-justify">
          <app-tab :tabs="tabsHorizontal" type="horizontal" />
        </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";

export default {
  name: "SiteViewModal",
  mixins: [ModalMixin],
  props: {
    id: Number,
    url: String,
    type: String,
  },
  data() {
    return {
      modalId: "form-view-Modal",
      modalTitle: this.$t("add"),
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Site Information",
          component: "mysite-information",
          permission: "",
          props: {id: this.id},
        },
        {
          icon: "link",
          name: "Site Tasks",
          component: "mysite-task",
          permission: "",
          props: {id: this.id, url: this.url, type: this.type},
        },
        {
          icon: "activity",
          name: "Site Log Book",
          component: "site-log-book",
          permission: "",
          props: {siteId: this.id, url: this.url, type: this.type},
        },
        {
          icon: "check-square",
          name: "Checkin/Checkout",
          component: "site-checkin",
          permission: "",
          props: {siteId: this.id, url: this.url, type: this.type},
        },
        {
          icon: "check-square",
          name: "Check-Call",
          component: "site-check-call",
          permission: "",
          props: {siteId: this.id, url: this.url, type: this.type},
        },

      ],
    };
  },
};
</script>
